{
  "sections": {
    "title": {
      "stream": "映像一覧",
      "device": "カメラ管理",
      "user": "ユーザー管理",
      "area": "エリア管理",
      "tag": "タグ管理",
      "recording": "録画再生",
      "clip": "キャプチャ一覧",
      "accountSettings": "アカウント設定",
      "companySettings": "企業設定",
      "firmware": "ファームウェア管理",
      "patlite": "パトランプ色検知",
      "handsLicense": "Handsライセンス管理",
      "viewer": "ビューワー",
      "samlLogin": "SSO ログイン",
      "login": "ログイン",
      "forgotPassword": "パスワードをお忘れの方",
      "resetPassword": "パスワード再設定"
    },
    "title2": "マップ管理",
    "title3": "マップ作成",
    "title4": "マップ編集"
  }
}
